import React, { useCallback, useState, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { Popup } from 'devextreme-react/popup'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import TreeList, { Column } from 'devextreme-react/tree-list'
import { Toolbar, Item } from 'devextreme-react/toolbar'
import { Setting } from '../../pages/settings/settings'
import { useIxAuth } from 'contexts/auth-context'
import ScrollView from 'devextreme-react/scroll-view'
import { IxUserRepresentationForCurrentUser } from 'components/user-representation-for-current-user/user-representation-for-current-user'
import { IxUserRepresentationActiveRelation } from 'components/user-representation-active/user-representation-active'
import { RootState } from 'slices'


import './user-section.scss'

export const UserSection = ({popupVisible, setPopupVisible}: any) => {
    const { t } = useTranslation()
    const [popupSettingsVisible, setPopupSettingsVisible] = useState(false)
    const [popupRepresentationForCurrentUser, setPopupRepresentationForCurrentUser] = useState(false)
    const [popupRepresentationActive, setPopupRepresentationActive] = useState(false)
    const { LNR, statusLNR } = useSelector((state: RootState) => state.rights)

    const { user, logout } = useIxAuth()
    const navigate = useNavigate()

    const isDevLicense = useMemo(() => statusLNR === 'loaded' && LNR === 999999, [LNR, statusLNR])

    const onLogout = useCallback(() => {
        logout && logout(() => navigate('/login', { state: { redirected: true } }))
    }, [logout, navigate])

    const navMenu = useMemo(() => {
        let menu = [
            {text: t('global:userSection.settings'), icon: 'dx-icon dx-icon-preferences', id: 1, onClick: () => {setPopupSettingsVisible(true)}},
            {text: t('global:userSection.yourProfile'), icon: 'dx-icon dx-icon-user', id: 2},
            {text: 'separator', id: 3,},
            {text: t('global:userSection.representColleague'), icon: 'dx-icon flaticon flaticon-agreement', id: 4, onClick: () => {setPopupRepresentationActive(true)}},
            {text: t('global:userSection.activateVacation'), icon: 'dx-icon flaticon flaticon-agreement', id: 5, onClick: () => {setPopupRepresentationForCurrentUser(true)}},
            {text: t('global:userSection.showMyAppointments'), icon: 'dx-icon flaticon flaticon-agreement', id: 6},
            {text: 'separator', id: 7,},
            {text: t('global:userSection.showUserRigtht'), icon: 'dx-icon flaticon flaticon-agreement', id: 8},
            {text: t('global:userSection.changeiXHausPassword'), icon: 'dx-icon flaticon flaticon-agreement', id: 9},
            {text: t('global:userSection.changeDMSPassword'), icon: 'dx-icon flaticon flaticon-agreement', id: 10},
            {text: 'separator', id: 11,},
            {text: t('global:button.logout'), icon: 'dx-icon flaticon flaticon-agreement', id: 12, onClick: onLogout},
        ];
        if (!isDevLicense) {
            menu = menu.filter(item => !(item.id >= 2 && item.id <= 11));
        }
        return menu;
    }, [t, onLogout, isDevLicense])

    const TitleRender = () => {
        return(
            <Toolbar>
                <Item location='before'>
                    <img src='/images/V-pink.svg' alt='avatar' height={50} width={60}/>
                </Item>
                <Item text={user ? user.firstName : 'No user'} location='before' />
                <Item widget='dxButton' location='after' options={{type: 'default', icon: 'close', onClick: () => {setPopupVisible(false)}}} />
            </Toolbar>
        )
    }

    const cellRender = useCallback((cell: any) => {
        return (
            cell.data.text === 'separator'
            ? <hr />
            : <div className='user-menu-item' onClick={cell.data.onClick}>
                <div className='item-icon'>
                    <i className={cell.data.icon} />
                </div>
                <span>
                    {t(cell.data.text)}
                </span>
            </div>
        )
    }, [t])

    return (
        <div>
            <Popup
                visible={popupVisible}
                showTitle={true}
                width={300}
                height={'auto'}
                onHiding={() => setPopupVisible(false)}
                position={ {at: 'right top', my: 'right top', of: 'window'}}
                titleRender={TitleRender}
                shading={true}
                hideOnOutsideClick={true}
                dragEnabled={false}
                wrapperAttr={{class: 'user-section'}}

            >
                <TreeList
                    keyExpr='id'
                    dataSource={navMenu}
                    showColumnHeaders={false}
                    showColumnLines={false}
                    showBorders={false}
                    showRowLines={false}
                    repaintChangesOnly={true}
                    dataStructure='plain'
                    width='auto'
                    height='100%'
                    className='user-menu-list'
                >
                    <Column
                        cellRender={cellRender}
                        width='100%'
                    />
                </TreeList>
            </Popup>

            <Popup
                visible={popupSettingsVisible}
                showCloseButton={true}
                onHiding={() => setPopupSettingsVisible(false)}
                width={700}
                height={'auto'}
                maxHeight={'95vh'}
                hideOnOutsideClick={true}
                title={t('global:userSection.settings')}
            >
            {
                popupSettingsVisible ? (
                    <ScrollView height='100%'>
                        <Setting />
                    </ScrollView>
                ) : <div></div>
            }
            </Popup>

            {isDevLicense ? (
            <IxUserRepresentationForCurrentUser mainUserId={user?.ixUserId} visiblePopup={popupRepresentationForCurrentUser} setVisiblePopup={setPopupRepresentationForCurrentUser}/>
            ) : null}
        
            {isDevLicense ? (
            <IxUserRepresentationActiveRelation mainUserId={user?.ixUserId} visiblePopup={popupRepresentationActive} setVisiblePopup={setPopupRepresentationActive}/>
            ) : null}
        </div>

    )
}
